module.exports = __webpack_public_path__ + "static/media/accenture_logo.649c1c77.PNG";